export enum IOCCodes {
  AFG = "AFG",
  ALB = "ALB",
  ALG = "ALG",
  ASA = "ASA",
  AND = "AND",
  ANG = "ANG",
  ANT = "ANT",
  ARG = "ARG",
  ARM = "ARM",
  ARU = "ARU",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BAH = "BAH",
  BRN = "BRN",
  BAN = "BAN",
  BAR = "BAR",
  BLR = "BLR",
  BEL = "BEL",
  BIZ = "BIZ",
  BEN = "BEN",
  BER = "BER",
  BHU = "BHU",
  BOL = "BOL",
  BIH = "BIH",
  BOT = "BOT",
  BRA = "BRA",
  IVB = "IVB",
  BRU = "BRU",
  BUL = "BUL",
  BUR = "BUR",
  BDI = "BDI",
  CAM = "CAM",
  CMR = "CMR",
  CAN = "CAN",
  CPV = "CPV",
  CAY = "CAY",
  CAF = "CAF",
  CHA = "CHA",
  CHI = "CHI",
  CHN = "CHN",
  COL = "COL",
  COM = "COM",
  COK = "COK",
  CRC = "CRC",
  CIV = "CIV",
  CRO = "CRO",
  CUB = "CUB",
  CYP = "CYP",
  CZE = "CZE",
  DEN = "DEN",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  COD = "COD",
  ECU = "ECU",
  EGY = "EGY",
  ESA = "ESA",
  GEQ = "GEQ",
  ERI = "ERI",
  EST = "EST",
  SWZ = "SWZ",
  ETH = "ETH",
  FIJ = "FIJ",
  FIN = "FIN",
  FRA = "FRA",
  GAB = "GAB",
  GAM = "GAM",
  GEO = "GEO",
  GER = "GER",
  GHA = "GHA",
  GRE = "GRE",
  GRN = "GRN",
  GUM = "GUM",
  GUA = "GUA",
  GUI = "GUI",
  GBS = "GBS",
  GUY = "GUY",
  HAI = "HAI",
  HON = "HON",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  INA = "INA",
  IRI = "IRI",
  IRQ = "IRQ",
  IRL = "IRL",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  KOS = "KOS",
  KUW = "KUW",
  KGZ = "KGZ",
  LAO = "LAO",
  LAT = "LAT",
  LIB = "LIB",
  LES = "LES",
  LBR = "LBR",
  LBA = "LBA",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAD = "MAD",
  MAW = "MAW",
  MAS = "MAS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTN = "MTN",
  MRI = "MRI",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MON = "MON",
  MGL = "MGL",
  MNE = "MNE",
  MAR = "MAR",
  MOZ = "MOZ",
  MYA = "MYA",
  NAM = "NAM",
  NRU = "NRU",
  NEP = "NEP",
  NED = "NED",
  NZL = "NZL",
  NCA = "NCA",
  NIG = "NIG",
  NGR = "NGR",
  PRK = "PRK",
  MKD = "MKD",
  NOR = "NOR",
  OMA = "OMA",
  PAK = "PAK",
  PLW = "PLW",
  PLE = "PLE",
  PAN = "PAN",
  PNG = "PNG",
  PAR = "PAR",
  PER = "PER",
  PHI = "PHI",
  POL = "POL",
  POR = "POR",
  PUR = "PUR",
  QAT = "QAT",
  CGO = "CGO",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  SKN = "SKN",
  LCA = "LCA",
  VIN = "VIN",
  SAM = "SAM",
  SMR = "SMR",
  STP = "STP",
  KSA = "KSA",
  SEN = "SEN",
  SRB = "SRB",
  SEY = "SEY",
  SLE = "SLE",
  SIN = "SIN",
  SVK = "SVK",
  SLO = "SLO",
  SOL = "SOL",
  SOM = "SOM",
  RSA = "RSA",
  KOR = "KOR",
  ESP = "ESP",
  SRI = "SRI",
  SUD = "SUD",
  SUR = "SUR",
  SWE = "SWE",
  SUI = "SUI",
  SYR = "SYR",
  TPE = "TPE",
  TJK = "TJK",
  TAN = "TAN",
  THA = "THA",
  TLS = "TLS",
  TOG = "TOG",
  TGA = "TGA",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  UAE = "UAE",
  GBR = "GBR",
  USA = "USA",
  ISV = "ISV",
  URU = "URU",
  UZB = "UZB",
  VAN = "VAN",
  VEN = "VEN",
  VIE = "VIE",
  YEM = "YEM",
  ZAM = "ZAM",
  ZIM = "ZIM"
}

export enum IOCByCountry {
  afghanistan = IOCCodes.AFG,
  albania = IOCCodes.ALB,
  algeria = IOCCodes.ALG,
  american_samoa = IOCCodes.ASA,
  andorra = IOCCodes.AND,
  angola = IOCCodes.ANG,
  antigua_barbuda = IOCCodes.ANT,
  argentina = IOCCodes.ARG,
  armenia = IOCCodes.ARM,
  aruba = IOCCodes.ARU,
  australia = IOCCodes.AUS,
  austria = IOCCodes.AUT,
  azerbaijan = IOCCodes.AZE,
  bahamas = IOCCodes.BAH,
  bahrain = IOCCodes.BRN,
  bangladesh = IOCCodes.BAN,
  barbados = IOCCodes.BAR,
  belarus = IOCCodes.BLR,
  belgium = IOCCodes.BEL,
  belize = IOCCodes.BIZ,
  benin = IOCCodes.BEN,
  bermuda = IOCCodes.BER,
  bhutan = IOCCodes.BHU,
  bolivia = IOCCodes.BOL,
  bosnia_herzegovina = IOCCodes.BIH,
  botswana = IOCCodes.BOT,
  brazil = IOCCodes.BRA,
  british_virgin_islands = IOCCodes.IVB,
  brunei = IOCCodes.BRU,
  bulgaria = IOCCodes.BUL,
  burkina_faso = IOCCodes.BUR,
  burundi = IOCCodes.BDI,
  cambodia = IOCCodes.CAM,
  cameroon = IOCCodes.CMR,
  canada = IOCCodes.CAN,
  cape_verde = IOCCodes.CPV,
  cayman_islands = IOCCodes.CAY,
  central_african_republic = IOCCodes.CAF,
  chad = IOCCodes.CHA,
  chile = IOCCodes.CHI,
  china = IOCCodes.CHN,
  colombia = IOCCodes.COL,
  comoros = IOCCodes.COM,
  cook_islands = IOCCodes.COK,
  costa_rica = IOCCodes.CRC,
  cote_divoire = IOCCodes.CIV,
  croatia = IOCCodes.CRO,
  cuba = IOCCodes.CUB,
  cyprus = IOCCodes.CYP,
  czechia = IOCCodes.CZE,
  denmark = IOCCodes.DEN,
  djibouti = IOCCodes.DJI,
  dominica = IOCCodes.DMA,
  dominican_republic = IOCCodes.DOM,
  dr_congo = IOCCodes.COD,
  ecuador = IOCCodes.ECU,
  egypt = IOCCodes.EGY,
  el_salvador = IOCCodes.ESA,
  equatorial_guinea = IOCCodes.GEQ,
  eritrea = IOCCodes.ERI,
  estonia = IOCCodes.EST,
  eswatini = IOCCodes.SWZ,
  ethiopia = IOCCodes.ETH,
  fiji = IOCCodes.FIJ,
  finland = IOCCodes.FIN,
  france = IOCCodes.FRA,
  gabon = IOCCodes.GAB,
  gambia = IOCCodes.GAM,
  georgia = IOCCodes.GEO,
  germany = IOCCodes.GER,
  ghana = IOCCodes.GHA,
  greece = IOCCodes.GRE,
  grenada = IOCCodes.GRN,
  guam = IOCCodes.GUM,
  guatemala = IOCCodes.GUA,
  guinea = IOCCodes.GUI,
  guinea_bissau = IOCCodes.GBS,
  guyana = IOCCodes.GUY,
  haiti = IOCCodes.HAI,
  honduras = IOCCodes.HON,
  hong_kong = IOCCodes.HKG,
  hungary = IOCCodes.HUN,
  iceland = IOCCodes.ISL,
  india = IOCCodes.IND,
  indonesia = IOCCodes.INA,
  iran = IOCCodes.IRI,
  iraq = IOCCodes.IRQ,
  ireland = IOCCodes.IRL,
  israel = IOCCodes.ISR,
  italy = IOCCodes.ITA,
  jamaica = IOCCodes.JAM,
  japan = IOCCodes.JPN,
  jordan = IOCCodes.JOR,
  kazakhstan = IOCCodes.KAZ,
  kenya = IOCCodes.KEN,
  kiribati = IOCCodes.KIR,
  kosovo = IOCCodes.KOS,
  kuwait = IOCCodes.KUW,
  kyrgyzstan = IOCCodes.KGZ,
  laos = IOCCodes.LAO,
  latvia = IOCCodes.LAT,
  lebanon = IOCCodes.LIB,
  lesotho = IOCCodes.LES,
  liberia = IOCCodes.LBR,
  libya = IOCCodes.LBA,
  liechtenstein = IOCCodes.LIE,
  lithuania = IOCCodes.LTU,
  luxembourg = IOCCodes.LUX,
  madagascar = IOCCodes.MAD,
  malawi = IOCCodes.MAW,
  malaysia = IOCCodes.MAS,
  maldives = IOCCodes.MDV,
  mali = IOCCodes.MLI,
  malta = IOCCodes.MLT,
  marshall_islands = IOCCodes.MHL,
  mauritania = IOCCodes.MTN,
  mauritius = IOCCodes.MRI,
  mexico = IOCCodes.MEX,
  micronesia = IOCCodes.FSM,
  moldova = IOCCodes.MDA,
  monaco = IOCCodes.MON,
  mongolia = IOCCodes.MGL,
  montenegro = IOCCodes.MNE,
  morocco = IOCCodes.MAR,
  mozambique = IOCCodes.MOZ,
  myanmar = IOCCodes.MYA,
  namibia = IOCCodes.NAM,
  nauru = IOCCodes.NRU,
  nepal = IOCCodes.NEP,
  netherlands = IOCCodes.NED,
  new_zealand = IOCCodes.NZL,
  nicaragua = IOCCodes.NCA,
  niger = IOCCodes.NIG,
  nigeria = IOCCodes.NGR,
  north_korea = IOCCodes.PRK,
  north_macedonia = IOCCodes.MKD,
  norway = IOCCodes.NOR,
  oman = IOCCodes.OMA,
  pakistan = IOCCodes.PAK,
  palau = IOCCodes.PLW,
  palestine = IOCCodes.PLE,
  panama = IOCCodes.PAN,
  papua_new_guinea = IOCCodes.PNG,
  paraguay = IOCCodes.PAR,
  peru = IOCCodes.PER,
  philippines = IOCCodes.PHI,
  poland = IOCCodes.POL,
  portugal = IOCCodes.POR,
  puerto_rico = IOCCodes.PUR,
  qatar = IOCCodes.QAT,
  republic_of_congo = IOCCodes.CGO,
  romania = IOCCodes.ROU,
  russia = IOCCodes.RUS,
  rwanda = IOCCodes.RWA,
  st_kitts_nevis = IOCCodes.SKN,
  st_lucia = IOCCodes.LCA,
  st_vincent_grenadines = IOCCodes.VIN,
  samoa = IOCCodes.SAM,
  san_marino = IOCCodes.SMR,
  sao_tome_principe = IOCCodes.STP,
  saudi_arabia = IOCCodes.KSA,
  senegal = IOCCodes.SEN,
  serbia = IOCCodes.SRB,
  seychelles = IOCCodes.SEY,
  sierra_leone = IOCCodes.SLE,
  singapore = IOCCodes.SIN,
  slovakia = IOCCodes.SVK,
  slovenia = IOCCodes.SLO,
  solomon_islands = IOCCodes.SOL,
  somalia = IOCCodes.SOM,
  south_africa = IOCCodes.RSA,
  south_korea = IOCCodes.KOR,
  spain = IOCCodes.ESP,
  sri_lanka = IOCCodes.SRI,
  sudan = IOCCodes.SUD,
  suriname = IOCCodes.SUR,
  sweden = IOCCodes.SWE,
  switzerland = IOCCodes.SUI,
  syria = IOCCodes.SYR,
  taiwan = IOCCodes.TPE,
  tajikistan = IOCCodes.TJK,
  tanzania = IOCCodes.TAN,
  thailand = IOCCodes.THA,
  timor_leste = IOCCodes.TLS,
  togo = IOCCodes.TOG,
  tonga = IOCCodes.TGA,
  trinidad_tobago = IOCCodes.TTO,
  tunisia = IOCCodes.TUN,
  turkey = IOCCodes.TUR,
  turkmenistan = IOCCodes.TKM,
  tuvalu = IOCCodes.TUV,
  uganda = IOCCodes.UGA,
  ukraine = IOCCodes.UKR,
  united_arab_emirates = IOCCodes.UAE,
  united_kingdom = IOCCodes.GBR,
  united_states = IOCCodes.USA,
  united_states_virgin_islands = IOCCodes.ISV,
  uruguay = IOCCodes.URU,
  uzbekistan = IOCCodes.UZB,
  vanuatu = IOCCodes.VAN,
  venezuela = IOCCodes.VEN,
  vietnam = IOCCodes.VIE,
  yemen = IOCCodes.YEM,
  zambia = IOCCodes.ZAM,
  zimbabwe = IOCCodes.ZIM
}

export type IOC = IOCCodes | `${IOCCodes}` | IOCByCountry;
